import { I18n } from '../../interfaces/I18n';
import { SpeedProfile } from '../../interfaces/state-events/RoutingRequest';

export default {
	lengthMeasurement: 'km',

	labels: {
		sparda: 'Filialen und SB-Center',
		freeATM: 'Weitere Standorte zur kostenfreien Geldabhebung',
		publicDeg: 'Nur öffentlich zugänglich',
		additionalCB: 'Weitere Standorte zur kostenfreien Geldabhebung'
	},

	businessHours: {
		delimiter: '.'
	},

	searchView: {
		btnSubmitAltText: 'Suchen',
		btnFilterAltText: 'Filter öffnen',
		btnLocalizeAltText: 'Lokalisieren',
		searchTermPlaceholder: 'PLZ/Ort/Adresse eingeben',
		searchTermAgencyPlaceholder: 'Agenturname eingeben',
		localizeNotSupported: 'Ihr Browser unterstützt keine Geolokalisierung.',
		cantFindLocation: 'Ihr Standort konnte nicht ermittelt werden.'
	},

	resultsView: {
		btnMapText: 'zur Karte',
		amountOfResults(amount: number, onlyNumeric = false) {
			return amount > 0 || onlyNumeric ? `${amount} Ergebnisse` : 'keine Ergebnisse';
		},
		serverError: 'Bitte verändern Sie Ihre Suchkriterien.'
	},

	detailsView: {
		mobileBackButton: 'Zurück zur Suchanfrage',
		desktopCloseAltText: 'Detailseite schließen',
		businessHours: {
			openingHours: ['Öffnungszeiten', 'SB-Center Öffnungszeiten'],
			isOpen: 'jetzt geöffnet',
			isClosed: 'geschlossen',
			days: {
				mo: 'Montag',
				tu: 'Dienstag',
				we: 'Mittwoch',
				th: 'Donnerstag',
				fr: 'Freitag',
				sa: 'Samstag',
				su: 'Sonntag'
			}
		},
		contact: {
			title: 'Kontakt',
			tel: 'Telefon',
			telAdditionalText: '(Montag bis Donnerstag 8 bis 18 Uhr und Freitag von 8 bis 16 Uhr)',
			mobile: 'Mobil',
			fax: 'Fax',

			additionalContact: 'Weitere Kontaktmöglichkeiten',
			email: 'E-Mail',
			url: 'Website'
		},

		infoIcons: {
			SPADxBGR: 'Behindertengerecht'
		},

		information: {
			SPADxIFC: 'Immobilienfinanzcenter',
			SPADxBGR: 'Behindertengerecht',
			SPADxGAA: 'Geldausgabeautomat',
			SPADxGEA: 'Geldeinzahlungsautomat',
			SPADxGKL: 'Geldkartenlesegerät',
			SPADxGSB: 'Giroscanbox',
			SPADxKAD: 'Kontoauszugsdrucker',
			SPADxKIDC: 'Einzahlungsautomat für Kindersparkonten',
			SPADxKSB: 'Kundenselbstbedienungsterminal',
			SPADxMFT: 'Multifunktionsterminal',
			SPADxwww: 'Internetterminal'
		},

		vcard: 'Kontakt speichern',
		routing: 'Route berechnen',
		routingShort: 'Route',
		services: {
			title: 'Wir beraten Sie zu folgenden Themen:',
			services: [
				'Lebensversicherung',
				'Krankenversicherung',
				'Sachversicherung',
				'Bausparen',
				'Baufinanzierung',
				'Investment'
			]
		}
	},

	routingView: {
		speedProfile: {
			[SpeedProfile.Car]: 'Auto',
			[SpeedProfile.Bicycle]: 'Fahrrad',
			[SpeedProfile.Pedestrian]: 'zu Fuß'
		},
		yourLocation: 'Ihr Standort'
	}
} as I18n;
